import { Controller } from "@hotwired/stimulus"
import { Calendar } from "@fullcalendar/core"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin from "@fullcalendar/interaction"
import timeGridPlugin from "@fullcalendar/timegrid"
import allLocales from "@fullcalendar/core/locales-all"

export default class extends Controller {
  static values = { config: Object }

  connect() {
    this.mobileQuery = window.matchMedia("(max-width: 639px)")
    const config = {
      ...this.configValue,
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      locales: allLocales,
      headerToolbar: this.toolbarForViewport(),
      moreLinkText: (count) => `+${count}`,
      eventContent: (info) => this.renderEvent(info),
      eventDidMount: (info) => {
        const subtitle = info.event.extendedProps.subtitle
        info.el.title = [info.event.title, subtitle].filter(Boolean).join(" · ")
      },
      eventClick: (info) => {
        if (!info.event.url) return

        info.jsEvent.preventDefault()
        if (info.event.extendedProps.modal) {
          this.openModal(info.event.url)
        } else {
          window.Turbo.visit(info.event.url)
        }
      }
    }

    this.calendar = new Calendar(this.element.querySelector("#calendar"), config)
    this.calendar.render()
    this.handleViewportChange = () => {
      this.calendar?.setOption("headerToolbar", this.toolbarForViewport())
    }
    this.mobileQuery.addEventListener("change", this.handleViewportChange)
  }

  disconnect() {
    this.mobileQuery?.removeEventListener("change", this.handleViewportChange)
    this.calendar?.destroy()
  }

  toolbarForViewport() {
    return this.mobileQuery.matches
      ? { left: "prev,next", center: "title", right: "today" }
      : this.configValue.headerToolbar
  }

  renderEvent(info) {
    const wrapper = document.createElement("div")
    wrapper.className = "kz-calendar-event-content"

    const dot = document.createElement("span")
    dot.className = "kz-calendar-event-dot"
    dot.setAttribute("aria-hidden", "true")

    const copy = document.createElement("span")
    copy.className = "kz-calendar-event-copy"

    const title = document.createElement("span")
    title.className = "kz-calendar-event-title"
    title.textContent = info.event.title

    const time = document.createElement("span")
    time.className = "kz-calendar-event-time"
    time.textContent =
      info.timeText || info.event.extendedProps.subtitle || ""

    copy.append(title, time)
    wrapper.append(dot, copy)

    return { domNodes: [wrapper] }
  }

  async openModal(url) {
    try {
      const response = await fetch(url, {
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
      if (!response.ok) throw new Error("Unable to load appointment")

      window.Turbo.renderStreamMessage(await response.text())
    } catch (_error) {
      window.Turbo.visit(url)
    }
  }
}
